import React from "react";
import { BRL } from "@/lib/api";

export default function Receipt({ order }) {
  if (!order) return null;
  const base = {
    margin: "3px 0",
    fontSize: "17px",
    fontWeight: 700,
    lineHeight: 1.35,
  };
  const row = {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "17px",
    fontWeight: 700,
    lineHeight: 1.35,
    margin: "3px 0",
  };
  const divider = { margin: "4px 0", fontWeight: 700, overflow: "hidden", whiteSpace: "nowrap" };
  return (
    <div
      className="print-area hidden print:block"
      style={{
        width: "80mm",
        padding: "6px 8px",
        color: "#000",
        fontFamily: "monospace",
        fontWeight: 700,
        fontSize: "17px",
        lineHeight: 1.35,
      }}
    >
      <div style={{ textAlign: "center" }}>
        <h2 style={{ margin: 0, fontWeight: 900, fontSize: "24px" }}>PAULISTA'S LANCHES &amp; PIZZAS</h2>
        <p style={{ ...base, fontSize: "16px" }}>Rua José Pequeno 50, Alto Alegre</p>
        <p style={divider}>********************************</p>
      </div>
      <p style={{ ...base, fontSize: "20px", fontWeight: 900 }}>PEDIDO #{order.order_number}</p>
      <p style={base}>
        {new Date(order.created_at).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })}
      </p>
      <p style={base}>Cliente: {order.customer_name}</p>
      <p style={base}>Tel: {order.phone}</p>
      <p style={base}>
        {order.fulfillment_type === "retirada"
          ? "RETIRADA NO BALCAO"
          : `Endereco: ${order.address}${order.neighborhood ? ` (${order.neighborhood})` : ""}`}
      </p>
      <p style={base}>Pagamento: {order.payment_method}</p>
      <p style={divider}>********************************</p>
      {order.items.map((it, i) => (
        <div key={i} style={row}>
          <span style={{ paddingRight: 6 }}>{it.qty}x {it.name}</span>
          <span>{BRL(it.price * it.qty)}</span>
        </div>
      ))}
      <p style={divider}>********************************</p>
      {order.delivery_fee != null && (
        <>
          <div style={row}>
            <span>Subtotal</span>
            <span>{BRL(order.subtotal ?? order.total)}</span>
          </div>
          <div style={row}>
            <span>{order.fulfillment_type === "retirada" ? "Retirada" : "Taxa entrega"}</span>
            <span>{order.fulfillment_type === "retirada" ? "Gratis" : BRL(order.delivery_fee)}</span>
          </div>
          {order.card_fee > 0 && (
            <div style={row}>
              <span>Taxa cartao{order.card_fee_percent ? ` (${order.card_fee_percent}%)` : ""}</span>
              <span>{BRL(order.card_fee)}</span>
            </div>
          )}
        </>
      )}
      <div style={{ ...row, fontSize: "21px", fontWeight: 900, marginTop: 4 }}>
        <span>TOTAL</span>
        <span>{BRL(order.total)}</span>
      </div>
      {order.notes ? <p style={{ ...base, marginTop: 8 }}>Obs: {order.notes}</p> : null}
      <p style={{ ...base, textAlign: "center", marginTop: 10 }}>Obrigado pela preferencia!</p>
    </div>
  );
}
